var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompactIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.32632 18L0 16.6737L2.93684 13.7368H0.473684V11.8421H6.1579V17.5263H4.26316V15.0632L1.32632 18ZM16.6737 18L13.7368 15.0632V17.5263H11.8421V11.8421H17.5263V13.7368H15.0632L18 16.6737L16.6737 18ZM0.473684 6.1579V4.26316H2.93684L0 1.32632L1.32632 0L4.26316 2.93684V0.473684H6.1579V6.1579H0.473684ZM11.8421 6.1579V0.473684H13.7368V2.93684L16.6737 0L18 1.32632L15.0632 4.26316H17.5263V6.1579H11.8421Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompactIcon);
export default __webpack_public_path__ + "static/media/compactIcon.4407b49db0ac9b170f02d3ec89a07ac6.svg";
export { ForwardRef as ReactComponent };